import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahsphysiotherapy',
  templateUrl: './asahsphysiotherapy.component.html',
  styleUrls: ['./asahsphysiotherapy.component.scss']
})
export class AsahsphysiotherapyComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
